import {Component, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {PageLoaderService} from "./services/page-loader.service";
import {HeaderComponent} from "./components/header/header.component";
import {MatIconRegistry} from "@angular/material/icon";
import {environment} from "../environments/environment";
import {Capacitor} from "@capacitor/core";
import {LiveUpdate} from "@capawesome/capacitor-live-update";
import {UploadProgressHeaderComponent} from "./components/upload-progress-header/upload-progress-header.component";
import {MatDialog} from "@angular/material/dialog";
import {YesNoData, YesNoDialogComponent} from "./components/yes-no-dialog/yes-no-dialog.component";

/** Main component of the app */
@Component({
	selector: 'app-root',
	imports: [RouterOutlet, HeaderComponent, UploadProgressHeaderComponent],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
	constructor(private pageLoaderService:PageLoaderService,
	            private dialog:MatDialog,
	            private iconRegistry:MatIconRegistry) {
	}

	ngOnInit() {
		//startup and start listening for page loads
		this.pageLoaderService.startup();

		this.iconRegistry.setDefaultFontSetClass("material-symbols-outlined");

		if(Capacitor.isNativePlatform()) {
			setTimeout(() => this.changeDetection(), 3000);
		}
	}

	/**
	 * Check the mobile version of the application and make sure that it is up to date. If not, the user will be prompted
	 * to optionally update the app.
	 */
	private async changeDetection() {
		const current = await LiveUpdate.getCurrentBundle();
		console.info(`Starting change detection (channel:${environment.updateChannel}, current:${current?.bundleId})....`);

		//check the version and prompt if there is a new one
		const result = await LiveUpdate.sync({channel: environment.updateChannel});
		if(result.nextBundleId) {
			console.info(`New update available (${result.nextBundleId}), set to update on reload`);

			//ask the user if they want to install a new version of the app now
			this.dialog.open<YesNoDialogComponent, YesNoData, boolean>(
				YesNoDialogComponent, {
					data: {
						yes: "Yes",
						no: "No",
						title: "Update",
						message: "There's a new update available, would you like to update now?",
						disableClose: false
					}
				})
				.afterClosed()
				.subscribe(value => {
					if(value) {
						this.pageLoaderService.show("Applying update and reloading...");
						LiveUpdate.reload();
					}
				});
		} else {
			console.info("No update found");
		}
	}
}
